import React, { useState } from 'react'
import TrainRouteModal from './TrainRouteModal'
import './trainResults.css'

// Wired to GET /trains/train-list/ (see trainList.jsx / train.jsx for the
// search call). Outer card shell + departure/duration/arrival row reuse the
// exact same .resultCard/.resultCard__time/.resultCard__duration classes as
// flight/bus results (see FlightResults.jsx / BusResults.jsx). The
// class-price/availability grid below was a static mock with no backing
// field on this API (no fares, no seat availability) — commented out rather
// than deleted, in case a fares endpoint is added later.

const RUN_DAY_LETTERS = ['M', 'T', 'W', 'T', 'F', 'S', 'S']
const RUN_DAY_NAMES = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

// No seat-class/availability field on /trains/train-list/ yet — static
// placeholder tags for now, same set on every card.
const SEAT_TYPES = ['SL', '3A', '2A', '1A']

// const TRAIN_RESULT = {
//     trainNumber: '22896',
//     trainName: 'Vande Bharat Exp',
//     inactiveRunDays: [3],
//     departureTime: '2:39 pm',
//     departureCode: 'BBS',
//     departureCity: '(Bhubanes..)',
//     duration: '5 hr 51 min',
//     arrivalTime: '8:30 pm',
//     arrivalCode: 'HWH',
//     arrivalCity: '(Howrah)',
//     classes: [
//         { code: 'CC', price: '₹1515', status: 'CUR_AVL 304', time: 'Moments ago', color: 'green' },
//         { code: 'EC', price: '₹2565', status: 'CUR_AVL 24', time: '4 hrs ago', color: 'orange' },
//         { code: 'CC', price: '₹1750', status: 'AVL 3', time: 'Moments ago', color: 'red' },
//         { code: 'EC', price: '₹3090', status: 'AVL 31', time: '2 days ago', color: 'green', tatkal: true },
//     ],
//     availabilityNote: 'View 6 days availability',
// }

const formatTime = (value) => {
    if (!value) return ''
    const [hh, mm] = value.split(':')
    const hour = Number(hh)
    const period = hour >= 12 ? 'pm' : 'am'
    const displayHour = ((hour + 11) % 12) + 1
    return `${displayHour}:${mm} ${period}`
}

export const TrainResultCard = ({ item, fromCode, toCode }) => {
    const [routeOpen, setRouteOpen] = useState(false)
    const runningDays = new Set((item.running_days || '').split(',').map((d) => d.trim()))

    return (
        <div className='resultCard hoverLift'>
            <div className='trainResultCard__head'>
                <div className='trainResultCard__title'>
                    <span className='trainResultCard__number'>{item.train_number}</span>
                    <span className='trainResultCard__name'>{item.train_name}</span>
                </div>
                <div className='trainResultCard__headRight'>
                    <button type='button' className='trainResultCard__viewRoute commonGredientText' onClick={() => setRouteOpen(true)}>VIEW ROUTE</button>
                    <div className='trainResultCard__runsOn'>
                        Runs on:
                        <div className='trainResultCard__runsOnDays'>
                            {RUN_DAY_LETTERS.map((day, index) => (
                                <span
                                    key={index}
                                    className={`trainResultCard__runsOnDay ${runningDays.has(RUN_DAY_NAMES[index]) ? '' : 'trainResultCard__runsOnDay--inactive'}`}
                                >
                                    {day}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <div className='resultCard__main'>
                <div className='resultCard__time'>
                    <div className='resultCard__timeValue'>{formatTime(item.departure_time)}</div>
                    <div className='resultCard__timeCode'>{item.origin_code} {item.origin_station ? `(${item.origin_station})` : ''}</div>
                </div>
                <div className='resultCard__duration'>
                    <div className='resultCard__durationValue'>{item.running_time}</div>
                    <div className='resultCard__stops'>{item.distance_km ? `${item.distance_km} km` : ''} {item.train_type}</div>
                </div>
                <div className='resultCard__time'>
                    <div className='resultCard__timeValue'>{formatTime(item.arrival_time)}</div>
                    <div className='resultCard__timeCode'>{item.destination_code} {item.destination_station ? `(${item.destination_station})` : ''}</div>
                </div>
            </div>

            <div className='trainResultCard__seatTags'>
                {SEAT_TYPES.map((type) => (
                    <span className='trainResultCard__seatTag' key={type}>{type}</span>
                ))}
            </div>

            {/* No fares/seat-availability field on /trains/train-list/ — kept
                for reference against a future fares endpoint.
            <div className='trainResultCard__classGrid'>
                {item.classes.map((cls, index) => (
                    <div className={`trainResultCard__classBox trainResultCard__classBox--${cls.color}`} key={index}>
                        <div className='trainResultCard__classHead'>
                            <span className='trainResultCard__classCode'>{cls.code}</span>
                            <span className='trainResultCard__classPrice'>{cls.price}</span>
                        </div>
                        <div className='trainResultCard__classStatusRow'>
                            <span className='trainResultCard__classStatus'>{cls.status}</span>
                            <span className='trainResultCard__classTime'>{cls.time}</span>
                        </div>
                        {cls.tatkal && <div className='trainResultCard__tatkal'>TATKAL</div>}
                    </div>
                ))}
            </div>

            <button type='button' className='trainResultCard__availability commonGredientText'>{item.availabilityNote}</button>
            */}

            <TrainRouteModal open={routeOpen} onClose={() => setRouteOpen(false)} item={item} fromCode={fromCode} toCode={toCode} />
        </div>
    )
}

const TrainResults = ({ items, fromCode, toCode }) => {
    if (!items) {
        return <p className='resultFlight__empty'>Search for trains on the home page to see results here.</p>
    }
    if (!items.length) {
        return <p className='resultFlight__empty'>No trains found for this route and date.</p>
    }

    return (
        <div className='flightResults'>
            {items.map((item) => (
                <TrainResultCard item={item} fromCode={fromCode} toCode={toCode} key={item.id} />
            ))}
        </div>
    )
}

export default TrainResults
